module.exports = __webpack_public_path__ + "img/39.165aa521.jpg";